import { FormikValues } from "formik";

import { getFieldPath } from "../FormikField.utils";
import { FormikTextField } from "../FormikTextField";
import { FormikTextFieldProps } from "../FormikTextField.types";

/** A text field that keeps only ASCII digits as the user types — postal codes, court prefixes, numeric ids. */
export function FormikDigitsField<T extends FormikValues>(props: FormikTextFieldProps<T>) {
  const { formik, path, fieldName, slotProps, onChange } = props;
  const fullPath = getFieldPath(path, fieldName);

  const inputSlot = typeof slotProps?.input === "object" ? slotProps.input : {};
  const inputProps = (inputSlot as { inputProps?: Record<string, unknown> }).inputProps ?? {};

  return (
    <FormikTextField
      {...props}
      onChange={(event) => {
        void formik.setFieldValue(fullPath, event.target.value.replace(/[^0-9]/g, ""));
        onChange?.(event);
      }}
      slotProps={{
        ...slotProps,
        input: {
          ...inputSlot,
          inputProps: {
            inputMode: "numeric",
            ...inputProps,
          },
        },
      }}
    />
  );
}
